/**
 * Retrieves and provides a computed reference to application configuration.
 *
 * @function useConfigs
 * @returns {ComputedRef<Object>} A computed reference to the application configuration.
 *
 * @description
 * This composable:
 * - Accesses the configuration from the app config
 * - Returns a computed reference for reactive configuration access
 *
 * @example
 * const configs = useConfigs()
 * console.log(configs.value.country) // Access configuration values
 */
export const useConfigs = () => {
  const conf = useAppConfig().config
  return computed(() => conf)
}
